import React from 'react'

const EcommerceHeaderIcon = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="ecommerce-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(76, 175, 80, 1)" />
          <stop offset="100%" stopColor="rgba(69, 160, 73, 1)" />
        </linearGradient>
        <filter id="ecommerce-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Shopping bag with handle */}
      <path 
        d="M8 10L6 28C6 29.1046 6.89543 30 8 30H24C25.1046 30 26 29.1046 26 28L24 10H8Z" 
        stroke="url(#ecommerce-grad)" 
        strokeWidth="2" 
        fill="none"
        filter="url(#ecommerce-glow)"
      />
      
      {/* Handles */}
      <path 
        d="M12 10V8C12 5.79086 13.7909 4 16 4C18.2091 4 20 5.79086 20 8V10" 
        stroke="url(#ecommerce-grad)" 
        strokeWidth="2" 
        strokeLinecap="round"
        filter="url(#ecommerce-glow)"
      />
      
      {/* Price tag */}
      <rect x="14" y="14" width="8" height="6" rx="1" fill="url(#ecommerce-grad)" opacity="0.7"/>
      <text x="16" y="18.5" fontSize="5" fill="white" fontWeight="bold">%</text>
      
      {/* Sparkles */}
      <circle cx="10" cy="7" r="1.5" fill="url(#ecommerce-grad)" opacity="0.8"/>
      <circle cx="22" cy="7" r="1" fill="url(#ecommerce-grad)" opacity="0.6"/>
      <circle cx="6" cy="13" r="1" fill="url(#ecommerce-grad)" opacity="0.6"/>
      <circle cx="26" cy="13" r="1.5" fill="url(#ecommerce-grad)" opacity="0.8"/>
    </svg>
  )
}

export default EcommerceHeaderIcon
